
import {OfferType} from "@/store/store.event.type";
import {PropType} from "vue";

export default {
  name: "OfferOverviewSingle",
  props: {
    item: {
      type: Object as PropType<OfferType>,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  }
}
